export default __webpack_public_path__ + "static/media/book_open.9e60f355.svg";